var _a, _b, _c;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import _ from 'lodash';
import { CreateShareCodeApi } from '../../apis/create-share-code-api';
import { GetShareSettingsApi } from '../../apis/get-share-settings-api';
import { ShareType } from '../../apis/share-api';
import { SwitchPublicShareApi } from '../../apis/switch-public-share-api';
import { SpaceOrFolder } from '../../enums';
let ShareSettingsRepositoryImpl = class ShareSettingsRepositoryImpl {
    constructor(_getShareSettingsApi, _createShareCodeApi, _switchPublicShareApi) {
        this._getShareSettingsApi = _getShareSettingsApi;
        this._createShareCodeApi = _createShareCodeApi;
        this._switchPublicShareApi = _switchPublicShareApi;
    }
    async switchSharePublic(data) {
        const request = {
            share_id: data.spaceOrFolderId,
            share_status: data.shareStatus,
            share_type: data.type === SpaceOrFolder.FOLDER
                ? ShareType.FOLDER
                : ShareType.SPACE,
        };
        const response = await this._switchPublicShareApi.switchSharePublic(request);
        return response.free_share_status;
    }
    async createShareCode(data) {
        const request = {
            share_expiry_at: data.shareExpiryAt,
            share_ids: [data.spaceOrFolderId],
            share_type: data.type === SpaceOrFolder.FOLDER
                ? ShareType.FOLDER
                : ShareType.SPACE,
            sync_display_field: data.syncDisplayField,
        };
        const response = await this._createShareCodeApi.createShareCode(request);
        return response.share_code;
    }
    async getShareSettings(data) {
        const response = await this._getShareSettingsApi.getShareSettings(data);
        return this._convertResponseToShareSettings(response);
    }
    _convertResponseToShareSettings(response) {
        return {
            publicShared: response.free_share_status,
            sharedCount: response.shared_count,
            users: _.map(response.user_infos, userInfo => ({
                avatarColor: `#${Number(userInfo.receiver_info.avatar_color).toString(16)}`,
                avatarPattern: userInfo.receiver_info.avatar_pattern,
                type: userInfo.receiver_type,
            })),
        };
    }
};
ShareSettingsRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(GetShareSettingsApi)),
    __param(1, inject(CreateShareCodeApi)),
    __param(2, inject(SwitchPublicShareApi)),
    __metadata("design:paramtypes", [typeof (_a = typeof GetShareSettingsApi !== "undefined" && GetShareSettingsApi) === "function" ? _a : Object, typeof (_b = typeof CreateShareCodeApi !== "undefined" && CreateShareCodeApi) === "function" ? _b : Object, typeof (_c = typeof SwitchPublicShareApi !== "undefined" && SwitchPublicShareApi) === "function" ? _c : Object])
], ShareSettingsRepositoryImpl);
export { ShareSettingsRepositoryImpl };
